module.exports = __webpack_public_path__ + "img/photo-26.fe98b280.jpg";